import * as React from 'react';
import injectSheet from 'react-jss';
import { TweenMax, Back, Power4 } from 'gsap';
import classNames from 'classnames';
import checkMark from './checkmark.svg';

const styleSheet = (theme: any) => ({
  error: theme.button.error,
  wrapper: {
    display: 'flex',
    marginLeft: '2%',
    '@media (max-width: 1000px)': {
      maxWidth: '660px',
      margin: '0 auto',
    },
  },
  blueBox: {
    cursor: 'pointer',
    width: '16px',
    height: '16px',
    borderRadius: '2px',
    paddingRight: '10px',
    outline: 0,
    backgroundColor: '#085fe5',
    position: 'relative',
    border: 0,
    '&:focus': {
      outline: '2px solid gold',
    },
  },
  whiteBox: {
    width: '16px',
    height: '16px',
    borderRadius: '2px',
    position: 'absolute',
    backgroundColor: '#fff',
    left: 0,
    top: 0,
    border: 'solid 2px #085fe5',
    boxSizing: 'border-box',
  },
  check: {
    transform: 'scale(0)',
    top: 0,
    left: '2px',
    position: 'absolute',
  },
  text: {
    color: '#6373a4',
    fontSize: '14px',
    margin: 0,
    marginLeft: '8px',
    cursor: 'pointer',
    textAlign: 'left',
    lineHeight: '23px',
    marginTop: '-3px',
    '& > a': {
      fontWeight: 'bold',
      textDecoration: 'none',
      color: '#6373a4',
    },
  },
});

interface Props {
  onClick?: (enabled: object) => void;
  classes?: any;
  enabled?: boolean;
  error?: boolean;
  name?: string;
  label?: string;
  type?: string;
  compressHeight?: boolean;
  onChange?: (e: any) => void;
}

const checkButton: React.FC<Props> = props => {
  let white: any = null;
  let check: any = null;

  const [checked, setChecked] = React.useState(undefined);
  const animate = {
    toggle: (isEnabled: boolean | undefined) => {
      if (isEnabled) {
        TweenMax.to(white, 0.35, { scale: 0, ease: Back.easeIn });
        TweenMax.to(check, 0.35, {
          scale: 1,
          ease: Back.easeOut,
          delay: 0.35,
        });
      } else {
        TweenMax.to(white, 0.35, {
          scale: 1,
          ease: Power4.easeOut,
          delay: 0.35,
        });
        TweenMax.to(check, 0.35, { scale: 0, ease: Back.easeIn });
      }
    },
  };

  React.useEffect(() => {
    if (checked !== undefined) animate.toggle(checked);
  });

  const handleClick = () => {
    const newState = !checked;
    setChecked(newState);
    props.onChange({ target: { value: newState, fieldId: props.name } });
  };

  return (
    <div className={props.classes.wrapper}>
      <button
        aria-label={`${props.children}`}
        type="button"
        onClick={() => {
          handleClick();
        }}
        onKeyDown={event => {
          if (event.key === 'Enter') {
            event.stopPropagation();
            event.preventDefault();
            handleClick();
          }
        }}
        className={props.classes.blueBox}
        tabIndex={0}
      >
        <img
          alt="checkmark"
          className={props.classes.check}
          aria-hidden="true"
          width="12"
          height="15"
          src={checkMark}
          ref={item => {
            check = item;
          }}
        />
        <div
          aria-hidden="true"
          id="checkbox"
          ref={item => {
            white = item;
          }}
          className={classNames(props.classes.whiteBox, {
            [props.classes.error]: props.error,
          })}
        />
      </button>
      <p
        role="presentation"
        aria-hidden="true"
        onClick={() => handleClick()}
        onKeyDown={event => {
          if (event.key === 'Enter') {
            event.stopPropagation();
            event.preventDefault();
            handleClick();
          }
        }}
        className={props.classes.text}
      >
        {props.children}
      </p>
    </div>
  );
};

export default injectSheet(styleSheet)(checkButton);
